<!-- 商品列表筛选 -->
<template>
  <div class="contents">
    <div class="ope-wrap">
      <ul class="filter-wrap">
        <li
          id="li1"
          :class="{ active: isTabActive == '默认' }"
          @click="tabChangeHandle('默认')"
        >
          <!-- <i class="line-top"></i> -->
          <span class="sort-name pointer w-60">默认</span>
        </li>
        <li
          :class="{ active: isTabActive == '销量' }"
          @click="tabChangeHandle('销量')"
        >
          <span class="sort-name break-line sale-num pointer w-60">销量</span>
        </li>
        <li
          :class="{ active: isTabActive == '价格' }"
          @click="sortByPrice('价格')"
        >
          <p class="sort-name pointer sort-price w-60">
            价格
            <span
              ><img
                style="margin-bottom: 4px"
                class="sort-icon"
                :src="isRanking == 1 ? defaultArrow.sUp : defaultArrow.dUp"
                alt="" /><img
                class="sort-icon"
                :src="isRanking == 2 ? defaultArrow.sDown : defaultArrow.dDown"
                alt=""
            /></span>
          </p>
        </li>
        <li
          :class="{ active: isTabActive == '产品质量评价' }"
          @click="tabChangeHandle('产品质量评价')"
        >
          <span class="sort-name break-line product-qu pointer"
            >产品质量评价</span
          >
        </li>
        <li class="address pointer" style="visibility: hidden">
          <span>配送至：</span>
          <div class="address-box">
            <p>
              <span>{{ showProvince }}</span
              >&nbsp;&nbsp;
              <span>{{ showCity }}</span>
            </p>
            <!-- <i class="arrow-down"></i> -->
            <img
              class="arrow-down"
              src="@/assets/img/product/icon-address-down@2x.png"
              alt=""
            />
          </div>
          <div class="address-list">
            <div class="p-c">
              <span
                class="active-city"
                :class="[isShow ? 'active' : '']"
                @click="isShow = true"
                >{{ provinceName
                }}<img
                  src="@/assets/img/product/select-open-down-product@2x.png"
                  alt=""
              /></span>
              <span
                class="active-city"
                :class="[!isShow ? 'active' : '']"
                @click="isShow = false"
                >{{ cityName
                }}<img
                  style="width: 9px; margin-left: 10px"
                  src="@/assets/img/product/select-open-down-product@2x.png"
                  alt=""
              /></span>
            </div>
            <div class="p-c-list">
              <ul v-show="isShow">
                <li
                  v-for="item in provice"
                  :key="item.areaCode"
                  :class="{
                    'select-province': isActiveProvince == item.areaCode,
                  }"
                  @click="
                    selectArea('province', item.areaCode, item.provinceName)
                  "
                >
                  {{ item.provinceName }}
                </li>
              </ul>
              <ul v-show="!isShow">
                <li
                  v-for="item in city"
                  :key="item.areaCode"
                  :class="{
                    'select-province': isActiveCity == item.areaCode,
                  }"
                  @click="selectArea('city', item.areaCode, item.areaName)"
                >
                  {{ item.areaName }}
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li class="list-box" style="visibility: hidden">
          <div class="sort-name break-line">
            <span
              class="product-img pointer"
              :class="{ active: isCurrentList == 'big' }"
              @click="tapChange('big')"
            >
              <img src="@/assets/img/product/big-img-icon-nor1@2x.png" alt="" />
              <img
                src="@/assets/img/product/big-img-icon-choice1@2x.png"
                alt=""
              />
              大图</span
            >
            <span
              style="margin-left: 20px"
              class="product-img pointer"
              :class="{ active: isCurrentList == 'small' }"
              @click="tapChange('small')"
            >
              <img
                src="@/assets/img/product/small-img-icon-nor1@2x.png"
                alt=""
              />
              <img
                src="@/assets/img/product/small-img-icon-choice1@2x.png"
                alt=""
              />
              列表</span
            >
          </div>
        </li>
        <li
          style="flex: 1; text-align: right; padding-right: 10px; display: none"
        >
          <span class="total">{{ listFilterData.total }} <i>种</i></span>
        </li>
      </ul>
      <ul class="filter-wrap filter-warp-1">
        <li>
          <span class="check-box-wrap pointer" @click="selectCheckBox(2)"
            ><i class="check-box-em"></i
            ><i
              v-show="localCheckList.indexOf(2) != -1"
              class="check-box-hook"
            ></i>
            <img
              src="@/assets/img/product/together-buy@2x.png"
              alt="集采标签"
            />
          </span>
        </li>
        <li>
          <span class="check-box-wrap pointer" @click="selectCheckBox(1)"
            ><i class="check-box-em"></i
            ><i
              v-show="localCheckList.indexOf(1) != -1"
              class="check-box-hook"
            ></i
            >推荐商品</span
          >
        </li>
        <li>
          <span class="check-box-wrap pointer" @click="selectCheckBox(3)"
            ><i class="check-box-em"></i
            ><i
              v-show="localCheckList.indexOf(3) != -1"
              class="check-box-hook"
            ></i
            >可用易权通</span
          >
        </li>
        <li v-if="isProtocol !== '62'">
          <span class="check-box-wrap pointer" @click="selectCheckBox(6)"
            ><i class="check-box-em"></i
            ><i
              v-show="localCheckList.indexOf(6) != -1"
              class="check-box-hook"
            ></i
            >惠享优品</span
          >
        </li>
        <!-- <li>
          <span class="check-box-wrap pointer" @click="selectCheckBox(7)"
            ><i class="check-box-em"></i><i v-show="localCheckList.indexOf(7) != -1" class="check-box-hook"></i>非标定制</span
          >
        </li> -->
        <li>
          <span class="check-box-wrap pointer" @click="selectCheckBox(8)"
            ><i class="check-box-em"></i
            ><i v-show="checkList.indexOf(8) != -1" class="check-box-hook"></i
            >仅显示有货</span
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    listFilterData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    checkList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      isCurrentList: 'big',
      isActiveProvince: '110000',
      isActiveCity: '',
      isTabActive: '默认',
      isRanking: null,
      provice: [
        { name: '北京' },
        { name: '北京1' },
        { name: '北京2' },
        { name: '北京3' },
        { name: '北京4' },
        { name: '北京5' },
        { name: '北京6' },
        { name: '北京7' },
      ],
      city: [],
      provinceName: '北京市',
      cityName: '北京市',
      showProvince: '北京市',
      showCity: '北京市',
      defaultArrow: {
        dUp: require('@/assets/img/product/icon-up-arrow@2x.png'),
        dDown: require('@/assets/img/product/icon-down-arrow@2x.png'),
        sUp: require('@/assets/img/product/icon-up-arrow-color1@2x.png'),
        sDown: require('@/assets/img/product/icon-down-arrow-color1@2x.png'),
      },
      // checkList: [],
      localCheckList: this.checkList,
      isShow: true,
      isProtocol: '',
    };
  },

  computed: {},

  created() {
    this.getSalesArea();
    this.isProtocol = this.$store.state.isProtocol;
  },
  methods: {
    tapChange(type) {
      this.isCurrentList = type;
      this.$emit('change', type);
    },
    selectCheckBox(num) {
      console.log(num);
      if (this.localCheckList.indexOf(num) !== -1) {
        this.localCheckList.splice(this.localCheckList.indexOf(num), 1);
      } else {
        this.localCheckList.push(num);
      }
      this.$emit('selectCheckBox', this.localCheckList);
      // this.$emit('selectCheckBox', this.checkList);
    },
    tabChangeHandle(type) {
      this.isTabActive = type;
      this.isRanking = null;
      this.$emit('tabChangeHandle', type);
    },
    sortByPrice(type) {
      this.isTabActive = type;
      if (this.isRanking == null) {
        this.isRanking = 1;
      } else if (this.isRanking === 1) {
        this.isRanking = 2;
      } else {
        this.isRanking = 1;
      }
      this.$emit('sortByPrice', this.isRanking, 'price');
    },
    // 获取配送区域
    async getSalesArea() {
      const res = await this.$request.queryProvinceList();
      if (res.code === '200') {
        this.provice = res.data;
      } else {
        this.$messgae.error(res.message);
      }
    },
    // 选择配送地址
    async selectArea(type, code, name) {
      // this.isActive = code;
      this.isShow = false;

      console.log(type);
      console.log(name);
      if (type === 'province') {
        this.isActiveProvince = code;
        const res = await this.$request.queryCityList({ provinceCode: code });
        if (res.code === '200') {
          this.city = res.data;
          this.provinceName = name;
          this.cityName = '请选择';
        } else {
          this.$messgae.error(res.message);
        }
      } else {
        this.isActiveCity = code;
        // this.isShow = true;
        this.cityName = name;
        this.showProvince = this.provinceName;
        this.showCity = this.cityName;
        this.$emit('sortByPrice', code, 'area');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/theme.scss';

.contents {
  // width: 958px;
  // height: 44px;
  margin: 0 0;
  background: #f5f5f5;
  border: 1px solid #d9d9d9;
  box-sizing: border-box;
  .filter-wrap {
    display: flex;
    // .line-top{
    //   height: 2px;
    //   background: $main-col;
    //   width: 100%;
    //   display: inline-block;
    li {
      flex-shrink: 0;
    }
    // }
    #li1 {
      position: relative;
    }

    & > li {
      height: 42px;
      line-height: 42px;
      font-size: 0;
      position: relative;
      display: flex;
      justify-content: flex-end;
      &.active {
        background: #fff;
        // border-top: 2px solid $main-col;
        color: $main-col;
        &:before {
          content: '';
          width: 100%;
          height: 2px;
          background: #007ee6;
          position: absolute;
          top: -2px;
          left: 0;
          right: 50%;
          transition: all 0.8s;
        }
        span {
          color: $main-col;
        }
        p {
          color: $main-col;
        }
      }
      .break-line {
        border-left: 1px solid #dcdcdc;
        border-right: 1px solid #dcdcdc;
      }
      .sort-name {
        font-size: 12px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #333333;
        padding: 10px;
        display: inline-block;
        line-height: 22px;
        text-align: center;
        height: 42px;
        &.sort-price {
          height: 44px;
          line-height: 44px;
          padding: 0 10px;
          display: flex;
          span {
            margin-left: 8px;
            display: flex;
            flex-flow: column;
            justify-content: center;
            align-items: center;
          }
          &:hover {
            color: $main-col;
          }
        }
      }
      .sort-icon {
        width: 8px;
      }

      .sale-num {
        padding-right: 20px;
        background: url('../../../../../assets/img/product/arrow-down1@2x.png')
          no-repeat 40px 50%;
        background-size: 10px;
        &:hover {
          color: $main-col;
          background: url('../../../../../assets/img/product/arrow-down-hover1@2x.png')
            no-repeat 40px 50%;
          background-size: 10px;
        }
      }
      .product-qu {
        padding-right: 23px;
        background: url('../../../../../assets/img/product/arrow-down1@2x.png')
          no-repeat 86px 50%;
        background-size: 10px;
        &:hover {
          color: $main-col;
          background: url('../../../../../assets/img/product/arrow-down-hover1@2x.png')
            no-repeat 86px 50%;
          background-size: 10px;
        }
      }
      .check-box-wrap {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 15px;
        position: relative;
        font-size: 12px;
        color: #666;
        img {
          height: 18px;
          // margin-left: -4px;
        }
        &:hover {
          .check-box-em {
            border: 1px solid $main-col;
          }
        }
        .check-box-em {
          margin-right: 6px;
          display: inline-block;
          width: 12px;
          height: 12px;
          background: #ffffff;
          border: 1px solid #d9d9d9;
        }
        .check-box-hook {
          display: inline-block;
          width: 12px;
          height: 12px;
          top: 15px;
          left: 0px;
          position: absolute;
          background: url('../../../../../assets/img/product/icon-select1@2x.png')
            no-repeat center center;
          background-size: 12px;
        }
      }
      .total {
        font-size: 12px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;

        color: #f0250f;
        // margin-left: 16px;
        font-weight: bold;
        i {
          font-style: normal;
          color: #333;
        }
      }
    }
    .address {
      display: flex;
      align-items: center;
      margin-left: 150px;
      position: relative;
      span {
        font-size: 12px;
      }
      &:hover {
        .address-list {
          display: block;
        }
      }
      .address-box {
        display: flex;
        align-items: center;
        width: 180px;
        height: 30px;
        background: #ffffff;
        border: 1px solid #d9d9d9;
        padding-left: 14px;
        padding-right: 10px;
        margin-left: 10px;
        justify-content: space-between;
        p {
          line-height: 30px;
          height: 30px;
        }
        span {
          font-size: 12px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #333333;
          flex-shrink: 0;
        }
        .arrow-down {
          // margin-left: 60px;
          width: 14px;
          // height: 14px;
        }
      }
      .address-list {
        display: none;
        position: absolute;
        top: 36px;
        left: 59px;
        width: 390px;
        height: 260px;
        background: #ffffff;
        box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.18);
        z-index: 100;
        img {
          width: 9px;
          margin-left: 10px;
        }
        .p-c {
          height: 38px;
          border-bottom: 1px solid $main-col;
          display: flex;
          padding: 12px 0 0 0;
          margin-left: 10px;
          span {
            margin-right: 10px;
            border-top: 1px solid #979797;
            border-left: 1px solid #979797;
            border-right: 1px solid #979797;
            border-bottom: 1px solid transparent;
            min-width: 72px;
            height: 26px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #333333;
            .active-city {
              width: 9px;
              margin-left: 10px;
            }
            &.active {
              border-left: 1px solid $main-col;
              border-right: 1px solid $main-col;
              border-top: 1px solid $main-col;
              &.active-city {
                border-bottom: 1px solid #ffffff;
                img {
                  width: 9px;
                  margin-left: 10px;
                }
              }
            }
          }
        }
        .p-c-list {
          font-size: 14px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #333333;
          padding: 19px 25px;
          height: 242px;
          overflow-y: auto;
          ul {
            display: flex;
            flex-wrap: wrap;
            // justify-content: space-between;
            li {
              line-height: 16px;
              text-align: center;
              margin-bottom: 18px;
              font-size: 12px;
              color: #333;
              height: 16px;
              margin-right: 10px;
              &.select-province {
                padding: 0 6px;
                height: 16px;
                background: $main-col;
                border-radius: 3px;
                line-height: 16px;
                color: #fff;
              }
            }
          }
        }
      }
    }
    .list-box {
      display: flex;
      align-items: center;
      margin-left: 192px;

      div {
        margin-left: 10px;
        display: flex;
        span {
          line-height: 1;
        }
      }
      .product-img {
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          margin-right: 6px;
          width: 15px;
          height: 15px;
        }
        img:nth-child(1) {
          display: block;
        }
        img:nth-child(2) {
          display: none;
        }
        &.active {
          font-size: 12px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: $main-col;
          img:nth-child(1) {
            display: none;
          }
          img:nth-child(2) {
            display: block;
          }
        }
        &:hover {
          font-size: 12px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: $main-col;
          img:nth-child(1) {
            display: none;
          }
          img:nth-child(2) {
            display: block;
          }
        }
      }
    }
  }
  .filter-warp-1 {
    border-top: 1px solid #d9d9d9;
  }
  .w-60 {
    width: 60px;
  }
}
</style>
